import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './paper.module.scss';

const Paper = ({ children, size, className }) => {
  return (
    <div className={cn(styles.paper, styles[size], className)}>{children}</div>
  );
};

export const PaperContainer = ({ children, className }) => (
  <div className={cn(styles.container, className)}>{children}</div>
);

export const PaperHeader = ({ children }) => (
  <div className={styles.header}>{children}</div>
);

export const PaperNav = ({ children }) => (
  <nav className={styles.nav}>{children}</nav>
);

export const PaperNote = ({ children }) => (
  <div className={styles.note}>{children}</div>
);

Paper.defaultProps = {
  size: 'sm',
};

Paper.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['xs', 'sm', 'lg']),
};

PaperContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

PaperHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

PaperNav.propTypes = {
  children: PropTypes.node.isRequired,
};

PaperNote.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Paper;
